module.exports = __webpack_public_path__ + "assets/img/dialog-bg.984b850d.png";